export default "__VITE_ASSET__CpkMeK8Y__"